import script from "./Manager.vue?vue&type=script&setup=true&lang=js"
export * from "./Manager.vue?vue&type=script&setup=true&lang=js"

import "./Manager.vue?vue&type=style&index=0&id=1ae9d858&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ae9d858"]])

export default __exports__